"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionSectionIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const QuestionSectionIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "0 0 64 64" }),
    react_1.default.createElement("path", { d: "M62.33,63.5H.33V1.5h62Zm-60-2h58V3.5h-58Z" }),
    react_1.default.createElement("rect", { x: "33.33", y: "11.5", width: "11.99", height: "2" }),
    react_1.default.createElement("rect", { x: "33.34", y: "19.5", width: "19.99", height: "2" }),
    react_1.default.createElement("rect", { x: "33.34", y: "27.5", width: "19.99", height: "2" }),
    react_1.default.createElement("rect", { x: "33.33", y: "35.5", width: "11.99", height: "2" }),
    react_1.default.createElement("rect", { x: "33.34", y: "43.5", width: "19.99", height: "2" }),
    react_1.default.createElement("path", { d: "M26.33,29.5h-18v-18h18Zm-16-2h14v-14h-14Z" }),
    react_1.default.createElement("path", { d: "M26.33,53.5h-18v-18h18Zm-16-2h14v-14h-14Z" })));
exports.QuestionSectionIcon = QuestionSectionIcon;
exports.default = exports.QuestionSectionIcon;
